import { observer } from 'mobx-react-lite';
import { useCallback, useEffect } from 'react';

import { useStores } from 'src/components/common/root-store-provider/root-store-provider';
import SelectOption, {
  OptionVariants,
} from 'src/components/main/quiz/select-option/select-option';
import { Policy } from 'src/widgets/policy';

import { fbAnalytics } from '@features/Analytics';
import { tikTokEvent } from '@features/Analytics/services/tik-tok-pixel';

import Cupid from '../../../../assets/images/quiz/cupid.svg';
import Fire from '../../../../assets/images/quiz/fire.svg';
import Ring from '../../../../assets/images/quiz/ring.svg';
import SpeechBalloon from '../../../../assets/images/quiz/speech-balloon.svg';
import { Image } from '../../../common/Image';
import styles from './welcome-screen-four-variants-ab-test.module.scss';

const BUTTONS_TEXT = [
  {
    value: 0,
    label: 'Sex',
    image: Fire,
  },
  {
    value: 1,
    label: 'Love',
    image: Cupid,
  },
  {
    value: 2,
    label: 'Marriage',
    image: Ring,
  },
  {
    value: 3,
    label: 'Intimacy',
    image: SpeechBalloon,
  },
];

const skipOption = {
  value: 4,
  text: 'Unlock all',
  image: (
    <Image src="arrow-right-white.svg" alt="arrow" width={20} height={20} />
  ),
};

const STARS = Array.from({ length: 10 }, (_, index) => (
  <span key={index} className={styles.star}></span>
));
export const WelcomeScreenFourVariantsABTest = observer(
  ({ onChange }: { onChange: (value: number) => void }) => {
    // @ts-ignore
    const fbLoaded = window.fbq !== undefined;
    // @ts-ignore
    const tikTokLoaded = window.ttq !== undefined;

    const {
      quizStore: { welcome, setWelcome },
    } = useStores();
    const handleClick = useCallback(
      (value: number) => {
        setWelcome(value);
        onChange(value);
      },
      [onChange, setWelcome],
    );

    useEffect(() => {
      if (fbLoaded) {
        fbAnalytics({
          eventName: 'ViewContent',
          postPath: 'event_start_onboard',
        });
      }
    }, [fbLoaded]);

    useEffect(() => {
      if (tikTokLoaded) {
        tikTokEvent('ViewContent');
      }
    }, [tikTokLoaded]);
    return (
      <div className={styles.container}>
        <header>
          <Image src="logo.webp" width={40} height={40} alt="logo" priority />
          <div>
            <h3>Eclipse</h3>
            <p>Personal moon phases calendar</p>
          </div>
        </header>
        <section className={styles.mainSection}>
          <p className={styles.title}>
            Check compatibility and find the perfect match!{' '}
          </p>
          <h3 className={styles.subtitle}>
            Get <b className={styles.subtitleBold}>practical guidances</b> to
            get rid of arguments and misunderstandings
          </h3>
          <div className={styles.optionsContainer}>
            {BUTTONS_TEXT.map(({ value: anotherValue, label, image }) => (
              <SelectOption
                key={`welcome_screen_four_variants_ab_test_${anotherValue}`}
                onChange={() => handleClick(anotherValue)}
                optionVariant={
                  welcome != null && anotherValue === welcome
                    ? OptionVariants.OptionSelected
                    : OptionVariants.OptionNotSelected
                }
                optionShapeType="square"
                image={image}
                label={label}
              />
            ))}
          </div>
          <button
            className={styles.unlock}
            onClick={() => handleClick(skipOption.value)}>
            <span className={styles.skipOption}>{skipOption.text}</span>{' '}
            {skipOption.image}
          </button>
        </section>
        <footer>
          <Policy className={styles.policy} place="burger_menu" />
        </footer>
        <section>{STARS}</section>
      </div>
    );
  },
);
